export const REVIEW_COPY = {
  entry: {
    title: (feature: string) => `How satisfied are you with ${feature}?`,
    great: 'Great',
    okay: 'Okay',
    notGood: 'Not good',
  },
  trustpilot: {
    title: "We're so glad we could help 💙",
    subtitle:
      "If PDF Genius made things easier today, we'd be truly grateful if you shared a quick review on Trustpilot.",
    leaveReview: 'Leave a review',
    waiting: 'Waiting for your review…',
    later: 'Maybe later',
  },
  feedback: {
    title: 'Something didn’t feel right?',
    subtitle:
      'Tell us what could be better. Your feedback helps us improve PDF Genius.',
    placeholder: 'What could we do better?',
    submit: 'Send feedback',
    skip: 'No thanks',
  },
  thankYou: {
    title: 'Thanks, that means a lot 💙',
    subtitle:
      "We're grateful for your time and support. It helps us grow and continue improving the experience.",
    continue: 'Continue',
  },
};

export const REVIEW_ILLUSTRATION: Record<
  'entry' | 'trustpilot' | 'feedback' | 'feedbackNotGood' | 'thankyou',
  { src: string; fit: 'cover' | 'contain'; bg: string }
> = {
  entry: { src: '/review-flow/entry.webp', fit: 'cover', bg: '#dfe7fb' },
  trustpilot: { src: '/review-flow/trustpilot.webp', fit: 'cover', bg: '#dfe7fb' },
  feedback: {
    src: '/images/reviewFlow/face-okey.webp',
    fit: 'cover',
    bg: '#dfe7fb',
  },
  feedbackNotGood: {
    src: '/review-flow/feedback-not-good.webp',
    fit: 'cover',
    bg: '#f4f5f7',
  },
  thankyou: { src: '/review-flow/thankyou.webp', fit: 'contain', bg: '#eaf0ff' },
};

export const NOT_GOOD_ILLUSTRATION = {
  bg: '#f4f5f7',
  faces: '/images/reviewFlow/face-not-good.webp',
};

export const THANKYOU_ILLUSTRATION = {
  bg: 'linear-gradient(160deg, #E8EEFF 0%, #C9D8FF 100%)',
  heart: '/images/reviewFlow/face-smile-heart.webp',
  smile: '/images/reviewFlow/thankyou-smile.webp',
};

export const REVIEW_PANEL_GRADIENT_BG =
  '/images/reviewFlow/review-gradient-bg.svg';
